import api, { checkTokenErrorResponse } from "..";

export async function postClassNotification(id, titulo, conteudo, sms = true, email = true) {
    return api.post(`turmas/${id}/notificacoes/`, {
        titulo,
        conteudo,
        sms,
        email
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postStudentNotification(id, titulo, conteudo, sms = true, email = true) {
    return api.post(`alunos/${id}/notificacoes/`, {
        titulo,
        conteudo,
        sms,
        email
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getStudentNotifications(id) {
    return api.get(`alunos/${id}/notificacoes/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const notificationServices = {
    postClassNotification,
    postStudentNotification,
    getStudentNotifications,
}
export default notificationServices;